import { SessionState } from "../model/session.state.model";
import { ReduxAction, RESET_PRIVATE_REDUX_STATE } from "../../../../core/redux/redux.module";
import {
  SESSION_FATAL_ERROR,
  SESSION_RESET,
  SESSION_REVIVE_RESET,
  SESSION_TICK,
  SESSION_WARNING_TIMEOUT_SET
} from "../action/session.action.factory";
import { RECEIVE_SESSION_REVIVE, RECEIVE_LOGOUT } from "../action/session.common.action.factory";
import { LocalStoreService } from "../../../../core/utils/local-store.service";

export function sessionReducer(state: SessionState, action: ReduxAction<any>): SessionState {

    // console.log("ooo--- session", state, action);
    if (!state || action.type === RESET_PRIVATE_REDUX_STATE) {
        state = {
            remainingTime: -1,
            reviveNeededIn: -1,
            sessionTime: -1,
            warningTimeOut: -1
        };
    }

    switch (action.type) {
        case SESSION_RESET:
            if (action.payload) {
                LocalStoreService.storeSessionTimeOut(action.payload);
            }
            return Object.assign( {}, state, {
                remainingTime: action.payload || state.sessionTime,
                reviveNeededIn: -1,
                sessionTime: action.payload || state.sessionTime
            });
        case SESSION_REVIVE_RESET:
            return Object.assign( {}, state, {
                remainingTime: state.remainingTime,
                reviveNeededIn: action.payload
            });
        case RECEIVE_SESSION_REVIVE:
            return Object.assign( {}, state, {
                remainingTime: state.remainingTime,
                reviveNeededIn: state.reviveNeededIn
            });
        case SESSION_WARNING_TIMEOUT_SET:
            if (action.payload) {
              LocalStoreService.storeSessionWarningTime(action.payload);
            }
            return Object.assign( {}, state, {
              warningTimeOut: action.payload
            });
        case SESSION_TICK:
            const newState: SessionState = Object.assign( {}, state, {
                remainingTime: state.remainingTime,
                reviveNeededIn: state.reviveNeededIn
            });

            if (newState.remainingTime > -1) {
                newState.remainingTime--;
            }

            if (newState.reviveNeededIn > -1) {
                newState.reviveNeededIn--;
            }
            return newState;
        case SESSION_FATAL_ERROR:
            return {
                remainingTime: -1,
                reviveNeededIn: -1,
                sessionTime: -1,
                warningTimeOut: -1,
                fatalError: true
            };
        case RECEIVE_LOGOUT:
            return {
              remainingTime: -1,
              reviveNeededIn: -1,
              sessionTime: -1,
              warningTimeOut: -1,
              fatalError: false
            };
        default:
            return state;
    }
}

